import { type ReactNode } from 'react';
import { fieldMessageStyles } from './util';

export function FieldWarning(props: { children: ReactNode }) {
	if (!props.children) {
		return null;
	}
	return <div className={fieldMessageStyles({ intent: 'warning' })}>{props.children}</div>;
}
